import { Injectable } from '@angular/core';
import { FeatureState } from '@modeso/aumico-lib-core-fe';
import type { ITextSnippetDTO } from '@modeso/types__aumico-lib-annualreport-be';
import { Store, select } from '@ngrx/store';
import Debug from 'debug';
import type { Observable } from 'rxjs';
import * as fromTextSnippetAction from '../actions/text-snippet.action';
import * as fromFeature from './../reducer/text-snippet.reducer';
import type { ITextSnippetProvider } from './text-snippet.provider.interface';

const debug = Debug('aumico:aumico-lib-annualreport-fe:TextSnippetProvider');
@Injectable({
    providedIn: 'root',
})
export class TextSnippetProvider implements ITextSnippetProvider {
    constructor(private readonly store: Store<FeatureState>) {
        debug('provider constructed');
    }

    public createTextSnippet(textSnippet: ITextSnippetDTO): void {
        this.store.dispatch(fromTextSnippetAction.CreateTextSnippet({ payload: textSnippet }));
    }

    public getAllTextSnippets$(): Observable<ITextSnippetDTO[]> {
        return this.store.pipe(select(fromFeature.SelectAllTextSnippets));
    }

    public dispatchTextSnippetsList(): void {
        this.store.dispatch(fromTextSnippetAction.GetAllTextSnippets());
    }

    public dispatchDeleteTextSnippets(ids: string[]): void {
        this.store.dispatch(fromTextSnippetAction.DeleteTextSnippets({ textSnippetsIds: ids }));
    }

    public dispatchUpdateTextSnippet(textSnippet: ITextSnippetDTO): void {
        this.store.dispatch(fromTextSnippetAction.UpdateTextSnippet({ payload: textSnippet }));
    }

    public dispatchGetTextSnippetById(id: string): void {
        this.store.dispatch(fromTextSnippetAction.GetTextSnippetById({ payload: id }));
    }

    public getSelectedTextSnippetById$(): Observable<ITextSnippetDTO> {
        return this.store.pipe(select(fromFeature.SelectSelectedTextSnippet));
    }

    public resetSelectedTextSnippet(): void {
        this.store.dispatch(fromTextSnippetAction.ResetSelectedTextSnippet());
    }
}
